import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuery from '../../services/api/axiosBaseQuery';
import { Tower } from '../../models/tower';
import { ApiResponse } from '../../services/httpService';
import { GetTowerParams } from '../../services/api/towerService';

const towersApiUrl = 'api/Towers';

export const towersService = createApi({
  reducerPath: 'towersService',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Towers'],

  endpoints: (builder) => ({
    getTowers: builder.query<ApiResponse<Tower>, GetTowerParams | undefined>(
      {
        query: (params?) => ({ url: towersApiUrl, params }),
        keepUnusedDataFor: 30,
        providesTags: ['Towers'],
      }
   ),
  }),
});

export const { useGetTowersQuery } = towersService;
